import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import { isInteger, hideWhenCreating, isNumeric, isCheckbox, hideWhenCreatingAndEditing, hideWhenDisplaying } from 'src/types/columnFlags';
import classUserRenderer from './components/classUserRenderer.vue';
const controlledActions = {
    create: [-1],
    fetch: [288],
    update: [-1],
    delete: [-1],
    downloadList: [288],
    uploadList: [-1]
};
const columns = () => {
    const commonDateProps = { isDateTime: true, displayTimeZoneField: 'studio_time_zone', timeZoneOptions: [{ name: 'studio_time_zone', label: 'Studio time zone' }], uiFilterTypes: ['dateFilters'] };
    return [
        { name: 'id', field: 'native_id', label: 'Native ID', style: 'width:70px;white-space:nowrap', align: 'left', hideWhenCreating, isNumeric, isInteger },
        { name: 'user_id', label: 'User ID', tooltipContent: 'Click to see the user\'s historical reservations', style: 'width:70px', field: 'user_id', align: 'left', hideWhenCreating: true, isNumeric: true, isInteger: true, component: classUserRenderer, componentProps2: ({ row }) => ({ userIdParam: (row.user_id || -1) }) },
        Object.assign(Object.assign({}, commonDateProps), { name: 'creation_date' }),
        Object.assign(Object.assign({}, commonDateProps), { name: 'cancel_date' }),
        Object.assign(Object.assign({}, commonDateProps), { name: 'checkin_date' }),
        { name: 'res_status_name', label: 'Status', align: 'left', uiFilterTypes: ['selectedValuesFilter'], labelColorMap: { removed: 'var(--theme-grey-30)', 'check in': 'var(--theme-green-20)', 'pending': 'var(--theme-green-30)', 'graced no show': 'var(--theme-red-20)', 'graced cancel': 'var(--theme-red-40)', 'penalty cancel': 'var(--theme-red-30)', 'penalty no show': 'var(--theme-red-40)', 'standard cancel': 'var(--theme-grey-30)' } },
        { name: 'res_type_name', label: 'Type', align: 'left', uiFilterTypes: ['selectedValuesFilter'], labelColorMap: { 'standard': 'var(--theme-30)', 'standby': 'var(--theme-red-30)', 'waitlist': 'var(--theme-orange-30)' } },
        { name: 'res_started_its_life_as_standby_pending', label: 'Standby', isCheckbox, headerInfoTip: 'Shows whether a reservation was originally created as a Standby reservation' },
        { name: 'studio_time_zone', hideWhenDisplaying, hideWhenCreatingAndEditing }
    ];
};
const localEntity = constructLocalEntity({
    columns,
    remoteEntityName: 'ci.reservations',
    apiVersion: 1,
    controlledActions,
    pageTitle: 'Reservations'
});
export default localEntity;
